// extracted by mini-css-extract-plugin
module.exports = {"backLinkBlocklock":"BackLink_backLinkBlocklock__3o3JI","backLinkBlocklock__dummy":"BackLink_backLinkBlocklock__dummy__YSrxs"};